import { isWfxAuthEnabled } from '@/utils/runtimeConfig';
import { getWfxSession } from '@/utils/wfxSession';
import { Navigate } from '@umijs/max';
import React from 'react';

type SessionGuardProps = {
  children?: React.ReactNode;
};

/**
 * Layout-level session gate. Do not register via route `wrappers` on parent
 * groups that use absolute child paths — Umi inserts an extra nested route
 * and React Router rejects those absolute children.
 */
export default function SessionGuard({ children }: SessionGuardProps) {
  if (!isWfxAuthEnabled()) {
    return <>{children}</>;
  }
  if (!getWfxSession()) {
    return <Navigate to="/401" replace />;
  }
  return <>{children}</>;
}
